import { render, staticRenderFns } from "./VideoCarousel.vue?vue&type=template&id=1e71692d&scoped=true"
import script from "./VideoCarousel.vue?vue&type=script&lang=js"
export * from "./VideoCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e71692d",
  null
  
)

export default component.exports